import React, { useState } from "react";
import { Slide, toast, ToastContainer } from "react-toastify";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import { Col, Row } from "react-bootstrap";
import RequiredLabel from "../lib/RequiredLabel";

function ContactForm({ handleClose }) {

    const [phone, setPhone] = useState('');
    const [entreprise, setEntreprise] = useState('');
    const [nom, setNom] = useState('');
    const [email, setEmail] = useState('');
    const [message, setMessage] = useState('');


    const [nomError, setNomError] = useState('');
    const [entrepriseError, setEntrepriseError] = useState('');
    const [emailError, setEmailError] = useState('');
    const [phoneError, setPhoneError] = useState('');
    const [messageError, setMessageError] = useState('');

    const [isSubmitting, setIsSubmitting] = useState(false);

    const validateForm = () => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

        setNomError('');
        setEntrepriseError('');
        setEmailError('');
        setPhoneError('');
        setMessageError('');

        if (!nom.trim()) {
            setNomError('Veuillez entrer votre nom et prénom.');
            return false;
        }

        if (!entreprise.trim()) {
            setEntrepriseError('Veuillez entrer votre société.');
            return false;
        }


        if (!email.trim()) {
            setEmailError('Veuillez entrer une adresse e-mail.');
            return false;
        }

        if (!emailRegex.test(email)) {
            setEmailError('Veuillez entrer une adresse e-mail valide.');
            return false;
        }

        if (!phone.trim()) {
            setPhoneError('Veuillez entrer un numéro valide.');
            return false;
        }

        if (!message.trim()) {
            setMessageError('Veuillez entrer un message.');
            return false;
        }

        return true;
    };

    const handleSubmit = async () => {
        if (!validateForm()) {
            return;
        }
        setIsSubmitting(true);

        const formData = {
            sujet: 'Demande de contact Groupe Talents Handicap',
            message,
            phone,
            nom,
            entreprise,
            sender: email,
            groupth: true,
        };

        try {
            const response = await fetch(process.env.REACT_APP_API_BASE_URL + '/contacts', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(formData),
            });
            if (response.ok) {
                console.log('Données envoyées avec succès');
                toast.success('Votre message a été envoyé avec succès !', {
                    onClose: () => {
                        if (typeof handleClose === 'function') {
                            handleClose();
                        }

                        setPhone('');
                        setEntreprise('');
                        setNom('');
                        setEmail('');
                        setMessage('');
                        setIsSubmitting(false);
                    },
                });
            } else {
                console.error('Une erreur est survenue lors de l\'envoi des données');
                toast.error('Une erreur est survenue lors de l\'envoi des données.');
                setIsSubmitting(false);
            }
        } catch (error) {
            console.error('Une erreur est survenue lors de la requête :', error);
            toast.error('Une erreur est survenue lors de la requête.');
            setIsSubmitting(false);
        }
    };

    return (
            <>
                <ToastContainer position="top-center" autoClose={5000} hideProgressBar={false} pauseOnHover
                                theme="colored" transition={Slide}/>
                <Form>
                    <Row>
                        <Col md={6}>
                            <Form.Group className="form-group mb-3" controlId="exampleForm.ControlInput1">
                                <Form.Label><RequiredLabel label="Nom et prénom" /></Form.Label>
                                <Form.Control
                                        type="text"
                                        name="nom"
                                        placeholder="Votre nom et prénom"
                                        required={true}
                                        value={nom}
                                        className="custom-placeholder"
                                        onChange={(e) => setNom(e.target.value)}
                                />
                                {nomError && <div style={{ color: '#AB3331', fontStyle: 'italic', fontSize: 'small' }}>{nomError}</div>}
                            </Form.Group>

                            <Form.Group className="form-group mb-3" controlId="exampleForm.ControlInput2">
                                <Form.Label><RequiredLabel label="Entreprise / Organisation" /></Form.Label>
                                <Form.Control
                                        type="text"
                                        name="entreprise"
                                        placeholder="Votre société"
                                        required={true}
                                        value={entreprise}
                                        className="custom-placeholder"
                                        onChange={(e) => setEntreprise(e.target.value)}
                                />
                                {entrepriseError && <div style={{ color: '#AB3331', fontStyle: 'italic', fontSize: 'small' }}>{entrepriseError}</div>}
                            </Form.Group>

                            <Form.Group className="form-group mb-3" controlId="exampleForm.ControlInput3">
                                <Form.Label><RequiredLabel label="E-mail"/></Form.Label>
                                <Form.Control type="email" name="email" placeholder="Votre e-mail"
                                              value={email} onChange={(e) => setEmail(e.target.value)}/>
                                {emailError && <div style={{ color: '#AB3331', fontStyle: 'italic', fontSize: 'small' }}>{emailError}</div>}
                            </Form.Group>
                            <Form.Group className="form-group mb-3" controlId="exampleForm.ControlInput4">
                                <Form.Label><RequiredLabel label="Téléphone"/></Form.Label>
                                <Form.Control type="text" name="telephone" placeholder="Votre téléphone"
                                              value={phone} onChange={(e) => setPhone(e.target.value)}/>
                                {phoneError && <div style={{ color: '#AB3331', fontStyle: 'italic', fontSize: 'small' }}>{phoneError}</div>}
                            </Form.Group>
                        </Col>
                        <Col md={6}>
                            <Form.Group className="form-group mb-3" controlId="exampleForm.ControlInput5">
                                <Form.Label><RequiredLabel label="Message"/></Form.Label>
                                <Form.Control as="textarea" rows={10} name="message" placeholder="Votre message" className="custom"
                                              value={message} onChange={(e) => setMessage(e.target.value)}/>
                                {messageError && <div style={{ color: '#AB3331', fontStyle: 'italic', fontSize: 'small' }}>{messageError}</div>}
                            </Form.Group>
                        </Col>
                    </Row>

                    <Row className={'justify-content-center'}>
                        <Button onClick={handleSubmit} disabled={isSubmitting} className="theme-btn btn-style-one small"
                                style={{width: "auto"}}>
                            {isSubmitting ? 'Envoi en cours...' : 'Envoyer'}
                        </Button>
                    </Row>
                </Form>
            </>
    );
}

export default ContactForm;
